export function sprintf(template: string, toReplace: string | string[] | number | number[]) {
  let result = template;
  let replacer = (Array.isArray(toReplace)) ? [...toReplace] : [toReplace];

  const re = /%\d/g;
  const matches = template.match(re) || [];

  if (matches.length && replacer.length) {
    result = (matches as string[]).reduce((acc: string, el: string, idx: number) => {
      return (replacer.length > idx) ? acc.replace(el, String(replacer[idx])) : acc;
    }, result);
  }

  return result;
}
